import React from 'react';

import ListPage from '@/src/shared/components/ListPage';
import useListSearch from '@/src/shared/hooks/useListSearch';

const AnnualReview = () => {
  const [loading, results] = useListSearch({
    pubCode: 845,
    yearsBack: 5,
  });

  return (
    <ListPage
      title="Market Conduct Annual Review"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      loading={loading}
    />
  );
};

export default AnnualReview;
